import React, { useState, useEffect } from "react";
import * as culori from "culori"; // Importação do culori para conversão

function App() {
  const [format, setFormat] = useState("rgb"); // Estado para controlar o formato
  const [rgb, setRgb] = useState({ r: 255, g: 0, b: 0 });
  const [hexValue, setHexValue] = useState("#ff0000"); // Estado para o valor HEX
  const [oklch, setOklch] = useState(culori.oklch(culori.rgb(rgb)));
  const [oklchColor, setOklchColor] = useState(""); // Estado para o valor de cor OKLCH

  // Atualiza o valor de oklchColor sempre que o valor de oklch mudar
  useEffect(() => {
    setOklchColor(`oklch(${oklch?.l ? oklch.l.toFixed(2) : 0} ${oklch?.c ? oklch.c.toFixed(2) : 0} ${oklch?.h ? oklch.h.toFixed(1) : 0}deg / ${oklch?.alpha ? oklch.alpha.toFixed(2) : 1})`);
  }, [oklch]);

  // Função para converter HEX para RGB
  function hexToRgb(hex) {
    const bigint = parseInt(hex.replace("#", ""), 16);
    return {
      r: (bigint >> 16) & 255,
      g: (bigint >> 8) & 255,
      b: bigint & 255,
    };
  }

  // Atualiza a cor RGB e converte para OKLCH
  const handleRgbChange = (e) => {
    const { name, value } = e.target;
    const updatedRgb = { ...rgb, [name]: Number(value) };
    setRgb(updatedRgb);
    setOklch(culori.oklch(culori.rgb(updatedRgb)));
    setHexValue(`#${((1 << 24) + (updatedRgb.r << 16) + (updatedRgb.g << 8) + updatedRgb.b)
      .toString(16)
      .slice(1)}`); // Atualiza hexValue quando RGB é alterado
  };

  // Manipula a mudança no campo HEX
  const handleHexChange = (e) => {
    const hex = e.target.value;
    setHexValue(hex); // Atualiza o estado hexValue diretamente
    if (/^#[0-9A-Fa-f]{6}$/.test(hex)) {
      const newRgb = hexToRgb(hex);
      setRgb(newRgb);
      setOklch(culori.oklch(culori.rgb(newRgb)));
    }
  };

  // Manipulador para alteração do formato
  const handleFormatChange = (e) => {
    setFormat(e.target.value);
    if (e.target.value === "hex") {
      // Atualiza hexValue ao mudar para HEX
      setHexValue(`#${((1 << 24) + (rgb.r << 16) + (rgb.g << 8) + rgb.b)
        .toString(16)
        .slice(1)}`);
    }
  };

  return (
    <div className="p-10 bg-gray-800 min-h-screen text-white font-sans">
      <h2 className="text-3xl font-bold mb-6">Conversor HEX e RGB para OKLCH</h2>

      {/* Seletor de formato */}
      <div className="mb-4">
        <label className="block mb-2 text-lg">Selecione o formato de entrada:</label>
        <select
          value={format}
          onChange={handleFormatChange}
          className="p-2 bg-gray-700 text-white rounded-md"
        >
          <option value="rgb">RGB</option>
          <option value="hex">HEX</option>
        </select>
      </div>

      {/* Entradas RGB */}
      {format === "rgb" && (
        <div className="flex gap-4">
          {['r', 'g', 'b'].map((color, idx) => (
            <label key={idx} className="relative group">
              <span className="block">{color.toUpperCase()}:</span>
              <input
                type="number"
                name={color}
                value={rgb[color]}
                min="0"
                max="255"
                onChange={handleRgbChange}
                className="w-20 p-2 bg-gray-700 text-white rounded-md"
              />
              <span className="absolute left-1/2 transform -translate-x-1/2 -bottom-10 hidden group-hover:block bg-black text-xs text-gray-200 rounded py-1 px-2">
                {`Intensidade de ${color.toUpperCase()} (0-255)`}
              </span>
            </label>
          ))}
        </div>
      )}

      {/* Entrada HEX */}
      {format === "hex" && (
        <label className="relative group">
          <span className="block">HEX:</span>
          <input
            type="text"
            name="hex"
            value={hexValue}
            maxLength="7"
            onChange={handleHexChange}
            className="w-28 p-2 bg-gray-700 text-white rounded-md"
          />
          <span className="absolute left-1/2 transform -translate-x-1/2 -bottom-10 hidden group-hover:block bg-black text-xs text-gray-200 rounded py-1 px-2">
            Código de cor HEX (e.g., #FF5733)
          </span>
        </label>
      )}

      {/* Exibição da cor resultante */}
      <div
        className="w-24 h-24 rounded-md mt-4"
        style={{
          backgroundColor: oklchColor,
        }}
      ></div>
      <p className="mt-4">Cor OKLCH atual: <span className="font-mono">{oklchColor}</span></p>
    </div>
  ); 
}

export default App;
